import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";

import { Layout } from "~/components/ui/layout";
import { Portlet, PortletTitle } from "~/components/ui/portlet";
import { useIntlDocumentTitle } from "~/hooks/use-document-title";
import { getBanners, selectBanners } from "~/slices/banners";
import { useAppDispatch, useAppSelector } from "~/store";

import { Banners } from "./promotion/banners";

export default function HomePage({ bareLayout }: { bareLayout?: boolean } = {}) {
  useIntlDocumentTitle("pat_table.block_banners");
  const dispatch = useAppDispatch();
  const banners = useAppSelector(selectBanners);
  const homeBanners = banners.filter((banner) => banner.align == "center");

  useEffect(() => {
    void dispatch(getBanners());
  }, [dispatch]);

  return (
    <Layout chrome={!bareLayout}>
      <Portlet as="main">
        <PortletTitle iconClassName="icon-pin">
          <FormattedMessage id="pat_table.block_banners" />
        </PortletTitle>

        <div id="carousel-home" className="carousel slide">
          <div className="carousel-inner" role="listbox">
            <Banners banners={homeBanners} mobile={true} />
          </div>
        </div>
      </Portlet>
    </Layout>
  );
}
